import React from 'react'
import { Link } from 'gatsby'
import { ImageResizer } from '../utils/imageResizer'

export default ({ page }) => {
  return (
    <section
      style={{
        backgroundImage:
          page.featured_media != null &&
          `url(${ImageResizer(
            page.featured_media.source_url,
            2600,
            null,
            true
          )})`,
      }}
      className="page-head"
    >
      <h1> {page.title} </h1>
      <div className="head-gradient">
        <Link className="arrow-wrapper" to={`/${page.slug}#page-content`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46.609"
            height="15.217"
          >
            <path
              d="M45.998 1.091L23.304 13.785.61 1.091"
              fill="none"
              stroke="#fff"
              strokeWidth="2.5"
            />
          </svg>
        </Link>
      </div>
    </section>
  )
}
